import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { concatMap, takeUntil } from 'rxjs/operators'
import { UnsubscribeOnDestroy } from '../../utility'

@Component({
    selector: 'app-accept-travel-agent-business-owner-invitation',
    templateUrl: 'accept-travel-agent-business-owner-invitation.html'
})
export class AcceptTravelAgentBusinessOwnerInvitationComponent extends UnsubscribeOnDestroy implements OnInit {

    constructor(private _activatedRoute: ActivatedRoute,
                private _router: Router) {
        super()
    }

    ngOnInit(): void {
        this._activatedRoute.paramMap
            .pipe(
                takeUntil(this.destroy$),
                concatMap((paramMap) => this._router.navigateByUrl(`/accept-invitation/${paramMap.get('invitationId')}`)),
            )
            .subscribe()
    }
}
